import { AfterViewInit, Component, Input, input } from '@angular/core';
import { BoxMetrics } from '../../interfaces/BoxMetrix';
import { MetricsRef } from '../../clases/MetricsRef';
import { HeaderValues } from '../../interfaces/HeaderValues';

@Component({
  selector: 'global-metrics',
  standalone: true,
  imports: [],
  templateUrl: './global-metrics.component.html',
  styleUrl: './global-metrics.component.scss'
})
export class GlobalMetricsComponent implements AfterViewInit{
   _metrics!: HeaderValues[];

  @Input()
  set metrics(value: HeaderValues[]) {
    this._metrics = value;
    this._metrics = this._metrics.sort((a, b)=> a.position - b.position);
  }
  get metrics() {
    return this._metrics;
  }

  ngAfterViewInit(): void {}
}
